import Button from 'components/Button';
import { ArrowRightIcon } from 'components/icons';
import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.colors.grey200};
  border-radius: 8px;
  overflow: hidden;
`;

export const Illustration = styled.img`
  display: block;
  width: 100%;
  height: 9.2rem;
  object-fit: cover;
  background-color: ${({ theme }) => theme.colors.greyBlue};
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background-color: ${({ theme }) => theme.colors.grey200};
  padding: 1rem;
`;

export const BoldLine = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
  font-size: 1rem;
  font-weight: ${({ theme }) => theme.weights.bold};
  line-height: 1.5;
`;

export const Paragraph = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
  font-size: 1rem;
  line-height: 1.5;
`;

export const Footer = styled.div`
  display: flex;
`;

export const ChallengeButton = styled(Button)`
  && {
    align-self: flex-start;
    align-items: center;
    width: fit-content;
    gap: 0.25rem;
    padding: 0.5rem 0.75rem;
  }
`;

export const ButtonArrow = styled(ArrowRightIcon)`
  width: 1.25rem;
  height: 1.25rem;
`;
